import React from 'react';
import SubHeaderComponent from '../../components/header/subheader';
import '../../assets/css/common/exit.css';
import '../../assets/css/common/alertModle.css';


export default class exit extends React.Component {
	constructor(){
		super();
		this.state = {
	      modal: false
	    };
	}
	componentDidMount(props) {
		
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	exitButtom(){
		let modal = this.state.modal;
		this.setState({
			modal: !modal
		})
	}
	exitBtn(index){
		this.exitButtom();
		if(index == 1){
			this.props.history.replace('/againlogin');
		}
	}
	render() {
		return(
			<div className={'exit'}>
				<SubHeaderComponent title="设置"></SubHeaderComponent>
				<div className={'exitButtom'} onClick={this.exitButtom.bind(this)}>
					退出登录
				</div>
				<div className={this.state.modal?'bg':'hide'}>
					<div className={'alertBox'}>
						<div className={'exitTitle'}>确定退出登录？</div>
						<div className={'exitCont'}>退出后不会删除任何历史数据，下次登录依然可以使用本账号</div>
						<button className={'btn1'} onClick={this.exitBtn.bind(this, '1')}>退出</button>
						<button onClick={this.exitBtn.bind(this, '2')}>取消</button>
					</div>
				</div>
		    </div>
		);
	}
}